import React from 'react'

// Removed Alert, Input, Modal imports
// Added CBAlert, CBInput, CBModal imports
import { CBAlert, CBInput, CBModal } from '../../../core/components/cbd';


const NewEmailModal = ({
  currentEmail,
  visible,
  handleOk,
  handleCancel,
  newEmail,
  setNewEmail,
  confirmLoading,
  emailInvalid,
}) => {
  const handleInputChange = (e) => {
    setNewEmail(e.target.value)
  }

  return (
    // Replaced Modal with CBModal
    <CBModal
      title="Edit License"
      visible={visible}
      onPositiveClick={handleOk} // Map onOk
      confirmLoading={confirmLoading} // Assuming CBModal supports this
      onCancelClick={handleCancel} // Map onCancel
    >
      <>
        <p className="mb-4">Change the email address for this account</p> {/* Added margin */}
        {/* Replaced Input.Group with div and spacing */}
        <div className="space-y-4">
          {/* Replaced Input with CBInput */}
          <CBInput
            label={'Current Email'} // Use label prop
            value={currentEmail}
            readOnly={true}
            className="pb-4"
          />
          <CBInput
            type={'email'}
            value={newEmail}
            label={'New Email'} // Use label prop
            placeholder={'New Email'}
            onChange={(val) => setNewEmail(val)} // Adapt onChange
            className="pb-4"
          />
        </div>
        {emailInvalid && (
          // Replaced Alert with CBAlert
          <CBAlert
            title="Error" // Use title prop
            message="New Email is not a valid email address" // Use message prop
            variant="error" // Map type
            className="mt-4" // Added margin
            // showIcon - Handled by CBAlert variant
          />
        )}
      </>
    </CBModal>
  )
}

export default NewEmailModal
